import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { API_VERSION, DIRECT_TRUST_PATH } from './RestApiConstants';


function deleteConnectedApplicationRequestConfig(id: String): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'DELETE',
    endpoint: `${DIRECT_TRUST_PATH}/${id}`,
    serverWideRequest: false
  };
}

export function callDeleteConnectedApplication(id: String) {
  return makeJsonRestApiRequest<void, IResult>({
    config: deleteConnectedApplicationRequestConfig(id),
    request: null,
  });
}

